import { SurveyDefinition, SurveyStepDefinition } from '../types/Survey';

export type SupportedSurveyPlatform = 'iOS' | 'Android' | 'Web';

const supportedAndroidSteps = new Set<string>([
    'CelebrationStep',
    'CompletionStep',
    'ConnectDeviceAccountStep',
    'ConnectEhrStep',
    'ConsentReviewStep',
    'ConsentStep',
    'CountdownStep',
    'EndOfSurveyStep',
    'FormStep',
    'InstructionStep',
    'QuestionStep',
    'VideoInstructionStep',
    'VisualConsentStep',
    'WebViewStep',
    'YouTubeStep'
]);

const supportedWebSteps = new Set<string>([
    'CelebrationStep',
    'CompletionStep',
    'ConnectDeviceAccountStep',
    'ConnectEhrStep',
    'ConsentReviewStep',
    'ConsentStep',
    'CountdownStep',
    'EndOfSurveyStep',
    'FormStep',
    'ImageCaptureStep',
    'InstructionStep',
    'QuestionStep',
    'VideoInstructionStep',
    'VisualConsentStep',
    'WaitStep',
    'WebViewStep',
    'YouTubeStep',
    'ConsentFormStep'
]);

const isCrossPlatformTemplateType = (templateType?: string): boolean => {
    return templateType === 'RKStudioOrderedTask' || templateType === 'RKStudioNavigableOrderedTask';
};

const evaluateStepSupport = (platforms: SupportedSurveyPlatform[], steps?: SurveyStepDefinition[]): SupportedSurveyPlatform[] => {
    if (!steps || !steps.length) {
        return platforms;
    }

    let nextPlatforms = [...platforms];
    for (const step of steps) {
        if (!supportedAndroidSteps.has(step.type)) {
            nextPlatforms = nextPlatforms.filter((platform) => platform !== 'Android');
        }

        if (!supportedWebSteps.has(step.type)) {
            nextPlatforms = nextPlatforms.filter((platform) => platform !== 'Web');
        }
    }

    return nextPlatforms;
};

export const getSurveyPlatforms = (definition?: SurveyDefinition | null): SupportedSurveyPlatform[] => {
    if (!definition) {
        return [];
    }

    if (!isCrossPlatformTemplateType(definition.type)) {
        return ['iOS'];
    }

    return evaluateStepSupport(['iOS', 'Android', 'Web'], definition.steps);
};
